import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      submit: {
         submit: () => ReturnType;
      };
   }
}

interface SubmitOptions {
   submit: () => void;
}

export const Submit = Extension.create<SubmitOptions>({
   name: 'submit',
   addOptions() {
      return {
         submit: () => {},
      };
   },
   addCommands() {
      return {
         submit: () => () => {
            this.options.submit();
            return true;
         },
      };
   },
   addKeyboardShortcuts() {
      return {
         'Mod-Enter': () => this.editor.commands.submit(),
      };
   },
});
